import React from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { Link } from "react-router-dom";

function PortfolioSix() {
  return (
    <div>
      <>
        {/* rmp portfolio mesonary area */}
        <div className="tmp-portfolio-area tmp-section-gapBottom"  style={{
        paddingBottom: '0px',
        paddingTop:"40px"
    }} >
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="section-head text-align-left">
                  <div className="section-sub-title text-align-left">
                    <img
                      src="assets/images/services/section-custom-menubar.png "
                      alt="Business_Consulting_services"
                    />
                    <span>OUR  Gallery</span>
                  </div>
                  <h2 className="title split-collab">
                  Captured Moments of Excellence


                  </h2>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="section-head  " style={{
                  display:"flex",
                  justifyContent:"end",
                  alignItems:"center"
                }}>
                  
                  <Link to={"gallery"} className="tmp-btn btn-primary">
                                           View Gallery
                                         </Link>
                </div>
              </div>
            </div>
          

            <div className="portfolio-area portfolio-style-three   bg_image bg-image-none">
              <div className="container">
                <div className="row g-5">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="portfolio-inner">
                      <a
                       
                        className="thumbnail"
                        data-tmp-cursor="lg"
                        data-tmp-cursor-text="View Details"
                      >
                        <img
                          src="assets/images/v2vimages/gallery-5.jpg"
                          alt="corporate business"
                        />
                      </a>
                      {/* <div className="portfolio-tag bg-gradiant">
                        <div className="content">
                          <Link to={"/ProjectDetails"}>
                            <h3 className="name animated fadeIn">
                           Lorem ipsum dolor 
                            </h3>
                          </Link>
                          <div className="designation"> Lorem ipsum dolor </div>
                        </div>
                        <Link
                         
                          className="icon angle-roted border-none bg-color-white"
                        >
                          <i className="fa-solid fa-arrow-right" />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="portfolio-inner">
                      <a
                       
                        className="thumbnail"
                        data-tmp-cursor="lg"
                        data-tmp-cursor-text="View Details"
                      >
                        <img
                        src="assets/images/v2vimages/gallery-1.jpg"
                          alt="corporate business"
                        />
                      </a>
                      {/* <div className="portfolio-tag bg-gradiant portfolio-sm-tag">
                        <div className="content">
                          <Link to={"/ProjectDetails"}>
                            <h3 className="name animated fadeIn">
                            Lorem ipsum dolor 
                            </h3>
                          </Link>
                          <div className="designation"> Lorem ipsum dolor </div>
                        </div>
                        <Link
                         
                          className="icon icon--30 radius-circle border-none bg-color-white"
                        >
                          <i className="fa-solid fa-arrow-right transform-rotate-318" />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="portfolio-inner">
                      <a
                       
                        className="thumbnail"
                        data-tmp-cursor="lg"
                        data-tmp-cursor-text="View Details"
                      >
                        <img
                          src="assets/images/v2vimages/gallery-2.jpg"
                          alt="business Corporate portfolio"
                        />
                      </a>
                      {/* <div className="portfolio-tag bg-gradiant portfolio-sm-tag">
                        <div className="content">
                          <Link to={"/ProjectDetails"}>
                            <h3 className="name animated fadeIn">
                            Lorem ipsum dolor 
                            </h3>
                          </Link>
                          <div className="designation"> Lorem ipsum dolor </div>
                        </div>
                        <Link
                         
                          className="icon icon--30 radius-circle border-none bg-color-white"
                        >
                          <i className="fa-solid fa-arrow-right transform-rotate-318" />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="portfolio-inner">
                      <a
                       
                        className="thumbnail"
                        data-tmp-cursor="lg"
                        data-tmp-cursor-text="View Details"
                      >
                        <img
                           src="assets/images/v2vimages/gallery-3.jpg"
                          alt="business Corporate portfolio"
                        />
                      </a>
                      {/* <div className="portfolio-tag bg-gradiant portfolio-sm-tag">
                        <div className="content">
                          <Link to={"/ProjectDetails"}>
                            <h3 className="name animated fadeIn">
                            Lorem ipsum dolor 
                            </h3>
                          </Link>
                          <div className="designation"> Lorem ipsum dolor </div>
                        </div>
                        <Link
                         
                          className="icon icon--30 radius-circle border-none bg-color-white"
                        >
                          <i className="fa-solid fa-arrow-right transform-rotate-318" />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="portfolio-inner">
                      <a
                       
                        className="thumbnail"
                        data-tmp-cursor="lg"
                        data-tmp-cursor-text="View Details"
                      >
                        <img
                         src="assets/images/v2vimages/gallery-4.jpg"
                          alt="business Corporate portfolio"
                        />
                      </a>
                      {/* <div className="portfolio-tag bg-gradiant portfolio-sm-tag">
                        <div className="content">
                          <Link to={"/ProjectDetails"}>
                            <h3 className="name animated fadeIn">
                            Lorem ipsum dolor 
                            </h3>
                          </Link>
                          <div className="designation"> Lorem ipsum dolor </div>
                        </div>
                        <Link
                         
                          className="icon icon--30 radius-circle border-none bg-color-white"
                        >
                          <i className="fa-solid fa-arrow-right transform-rotate-318" />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="portfolio-inner">
                      <a
                       
                        className="thumbnail"
                        data-tmp-cursor="lg"
                        data-tmp-cursor-text="View Details"
                      >
                        <img
                        src="assets/images/v2vimages/gallery-6.jpg"
                          alt="corporate business"
                        />
                      </a>
                      {/* <div className="portfolio-tag bg-gradiant">
                        <div className="content">
                          <Link  >
                            <h3 className="name animated fadeIn">
                            Lorem ipsum dolor 
                            </h3>
                          </Link>
                          <div className="designation"> Lorem ipsum dolor </div>
                        </div>
                        <Link
                          
                          className="icon angle-roted border-none bg-color-white"
                        >
                          <i className="fa-solid fa-arrow-right" />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* rmp portfolio mesonary area end */}
      </>
    </div>
  );
}

export default PortfolioSix;
